export default __webpack_public_path__ + "static/media/toggle.62a962e1.svg";